export class GameClock {
  private lastTime = 0;
  private accumulator = 0;
  private _fps = 0;
  private _frameCount = 0;
  private _fpsTimer = 0;
  readonly fixedDt: number;

  constructor(tickRate: number) {
    this.fixedDt = 1 / tickRate;
  }

  start(): void {
    this.lastTime = performance.now() / 1000;
  }

  update(): number {
    const now = performance.now() / 1000;
    const dt = Math.min(now - this.lastTime, 0.1); // cap at 100ms
    this.lastTime = now;
    this.accumulator += dt;

    this._frameCount++;
    this._fpsTimer += dt;
    if (this._fpsTimer >= 1) {
      this._fps = this._frameCount;
      this._frameCount = 0;
      this._fpsTimer -= 1;
    }

    return dt;
  }

  consumeFixedStep(): boolean {
    if (this.accumulator >= this.fixedDt) {
      this.accumulator -= this.fixedDt;
      return true;
    }
    return false;
  }

  get fps(): number {
    return this._fps;
  }

  get alpha(): number {
    return this.accumulator / this.fixedDt;
  }
}
